import {Component, input, Input} from '@angular/core';
import {AbstractControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MdbFormsModule} from "mdb-angular-ui-kit/forms";
import {MdbValidationModule} from "mdb-angular-ui-kit/validation";

import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-form-input',
    imports: [
    FormsModule,
    MdbFormsModule,
    MdbValidationModule,
    ReactiveFormsModule,
    TranslateModule
],
    templateUrl: './form-input.component.html',
    standalone: true,
    styleUrl: './form-input.component.scss'
})
export class FormInputComponent {
  id= input.required<string>();
  label= input.required<string>();
  controlName = input.required<string>();
  formGroup = input.required<FormGroup>()
  isRequired = input(false)
  hideLabel = input(false)
  type = input('text')
  placeholder = input<string>()
  minLength = input<number>()
  min = input<number>()
  max = input<number>()
  disabled = input<boolean>(false)
  allowDecimalNumbers = input<boolean>(false)

  get control(): AbstractControl | null {
    return this.formGroup().get(this.controlName())
  }

  preventNonNumeric(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight','ArrowUp', 'ArrowDown', 'Tab', 'Delete', 'Home', 'End'
    ];
    if(this.allowDecimalNumbers())
      allowedKeys.push(',')

    const isCtrlOrCmd = event.ctrlKey || event.metaKey;

    if (
      allowedKeys.includes(event.key) ||
      (isCtrlOrCmd && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) // allow Ctrl/Cmd + A/C/V/X
    ) {
      return; // Allow control keys
    }

    const numberPattern = /[0-9]/;

    if (!numberPattern.test(event.key)) {
      event.preventDefault(); // Block non-numeric input
    }
  }
}
